import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

export const WhatsAppTransparentCircularIcon = ({
  width = 16,
  height = 16,
  fill = '#16a34a'
}: SVGComponentProps) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="m0 16 1.149-4.265a7.88 7.88 0 0 1-.83-5.46A7.9 7.9 0 0 1 3.283 1.61a7.94 7.94 0 0 1 10.36.668 7.88 7.88 0 0 1 .805 10.316 7.93 7.93 0 0 1-4.643 3.013 7.95 7.95 0 0 1-5.489-.756zm4.523-2.745.267.157a6.42 6.42 0 0 0 7.757-.94 6.365 6.365 0 0 0 1.071-7.715 6.4 6.4 0 0 0-3.091-2.725 6.43 6.43 0 0 0-4.118-.28 6.4 6.4 0 0 0-3.434 2.282 6.37 6.37 0 0 0-1.324 3.897 6.3 6.3 0 0 0 .936 3.308l.168.275-.643 2.38z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.998 9.027a1.32 1.32 0 0 0-1.131-.257c-.294.121-.484.581-.674.811a.28.28 0 0 1-.362.081 5.12 5.12 0 0 1-2.56-2.186.306.306 0 0 1 .04-.424c.213-.209.368-.468.453-.753a1.64 1.64 0 0 0-.208-.901A2.1 2.1 0 0 0 5.9 4.41a.91.91 0 0 0-.972.15 2 2 0 0 0-.692 1.577q0 .252.063.496c.105.39.266.761.48 1.104q.23.395.501.762a7.7 7.7 0 0 0 2.176 2.01q.641.401 1.357.645c.494.224 1.04.31 1.579.248a1.9 1.9 0 0 0 1.429-1.059.9.9 0 0 0 .068-.541c-.082-.374-.584-.595-.891-.775"
        fill={fill}
      />
    </svg>
  </SVGUniqueID>
);
